import { AfterViewInit, Component, ElementRef, OnDestroy } from '@angular/core';

import { SkyPageSummaryAdapterService } from './page-summary-adapter.service';
import { SkyMediaBreakpoints, SkyMediaQueryService } from '../media-queries';
import { Subscription } from 'rxjs/Subscription';


export class SkyPageSummaryComponent implements OnDestroy, AfterViewInit {
  private breakpointSubscription: Subscription;

  constructor(
    private elRef: ElementRef,
    private adapter: SkyPageSummaryAdapterService,
    private mediaQueryService: SkyMediaQueryService
  ) { }

  public ngAfterViewInit() {
    this.breakpointSubscription = this.mediaQueryService.subscribe(
      (args: SkyMediaBreakpoints) => {
        this.adapter.updateKeyInfoLocation(this.elRef, args === SkyMediaBreakpoints.xs);
      }
    );
  }

  public ngOnDestroy() {
    /* istanbul ignore else */
    /* sanity check */
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary',
  template: `<div
    class="sky-page-summary"
    [ngClass]="{
      'sky-page-summary-with-key-info': keyInfoContainerEl.children.length > 0
    }"
>
  <ng-content select="sky-page-summary-alert"></ng-content>
  <div class="sky-page-summary-row">
    <div class="sky-page-summary-left">
      <ng-content select="sky-page-summary-image"></ng-content>
      <div>
        <ng-content select="sky-page-summary-title"></ng-content>
        <ng-content select="sky-page-summary-subtitle"></ng-content>
        <ng-content select="sky-page-summary-status"></ng-content>
        <div class="sky-page-summary-key-info-xs"></div>
        <ng-content select="sky-page-summary-content"></ng-content>
      </div>
    </div>
    <div class="sky-page-summary-key-info-sm">
      <div class="sky-page-summary-key-info-container" #keyInfoContainerEl>
        <ng-content select="sky-page-summary-key-info"></ng-content>
      </div>
    </div>
  </div>
</div>
`,
  styles: [`.sky-page-summary {
  background-color: #fff;
  padding: 20px 15px;
}

.sky-page-summary-row {
  align-items: stretch;
  display: flex;
}

@media (min-width: 768px) {
  .sky-page-summary-with-key-info .sky-page-summary-left {
    flex-basis: 75%;
    padding-right: 15px;
  }
  .sky-page-summary-with-key-info .sky-page-summary-right {
    flex-basis: 25%;
  }
  .sky-page-summary-left {
    align-items: stretch;
    display: flex;
  }
}
`],
  providers: [SkyPageSummaryAdapterService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: SkyPageSummaryAdapterService, },
{type: SkyMediaQueryService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
